import { useEffect } from 'react';
import { useDataFetchingClient, useQuery } from 'data-fetching-client';
import { useIframeableContext } from '../context/IframeableContext';
import { GET_CHECKOUT_SESSION } from '../data/queries';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { EMBED_MESSAGE_TYPES } from '../constants/Embed';
import { jsx as _jsx } from "react/jsx-runtime";
const PreviewCheckoutContainer = ({
  children
}) => {
  const client = useDataFetchingClient();
  const {
    iframeableContext
  } = useIframeableContext();
  const embeddedCheckoutSession = iframeableContext && iframeableContext.passthruProps && iframeableContext.passthruProps.checkoutSession;
  useEffect(() => {
    if (embeddedCheckoutSession && embeddedCheckoutSession.id) {
      client.writeQuery({
        query: GET_CHECKOUT_SESSION,
        data: {
          checkoutSession: embeddedCheckoutSession
        }
      });
    } else {
      iframeableContext.sendMessage(EMBED_MESSAGE_TYPES.MISSING_CHECKOUT_SESSION);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const {
    data
  } = useQuery(GET_CHECKOUT_SESSION, {
    fetchPolicy: 'cache-only'
  });
  const cachedCheckoutSession = data && data.checkoutSession;
  if (!cachedCheckoutSession) return /*#__PURE__*/_jsx(LoadingSpinner, {
    grow: true,
    minHeight: 200
  });
  return children;
};
export default PreviewCheckoutContainer;